/**
 * Reminders API - Reminder management endpoints
 */
import { apiClient } from '../../../core';

export const remindersApi = {
  // Reminders
  getReminders: () => apiClient.get('/reminders'),
  createReminder: (data) => apiClient.post('/reminders', data),
  updateReminder: (id, data) => apiClient.put(`/reminders/${id}`, data),
  deleteReminder: (id) => apiClient.delete(`/reminders/${id}`),

  // Attachments
  uploadAttachment: (reminderId, formData) =>
    apiClient.post(`/reminders/${reminderId}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  deleteAttachment: (reminderId, attachmentId) =>
    apiClient.delete(`/reminders/${reminderId}/attachments/${attachmentId}`),

  // Categories
  getCategories: () => apiClient.get('/reminders/categories'),
  createCategory: (data) => apiClient.post('/reminders/categories', data),
  updateCategory: (id, data) => apiClient.put(`/reminders/categories/${id}`, data),
  deleteCategory: (id) => apiClient.delete(`/reminders/categories/${id}`),

  // Sharing
  shareReminder: (id, data) => apiClient.post(`/reminders/${id}/share`, data),
  unshareReminder: (id, userId) => apiClient.delete(`/reminders/${id}/share/${userId}`),
};
